import React from "react";
import { cn } from "@/lib/utils";

/**
 * EmptyState — UI-2C2 shared, on-brand empty / no-results block.
 *
 * Light/warm, left-system-aligned centred layout for public listings and
 * search results. Presentation only — it adds no behaviour of its own.
 *
 * Props:
 * - icon        lucide component (e.g. `icon={Music}`) — rendered at a
 *               consistent size; optional
 * - title       string | node   heading
 * - description string | node   optional supporting line
 * - action      node            optional existing action (button/link)
 * - className   string          extra wrapper classes
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  ...props
}) {
  return (
    <div
      data-testid="empty-state"
      className={cn(
        "flex flex-col items-center justify-center text-center py-16 px-6",
        className
      )}
      {...props}
    >
      {Icon && (
        <Icon className="w-16 h-16 text-stone-300 mb-4" aria-hidden="true" />
      )}
      {title && (
        <h3
          data-testid="empty-state-title"
          className="text-xl sm:text-2xl font-bold text-stone-700 mb-2"
        >
          {title}
        </h3>
      )}
      {description && (
        <p className="max-w-md text-base text-stone-500">{description}</p>
      )}
      {action && (
        <div data-testid="empty-state-action" className="mt-6">
          {action}
        </div>
      )}
    </div>
  );
}

export default EmptyState;
